import { PageHeader } from '../components/ui';
import TimeOffEditor from '../components/TimeOffEditor';

/**
 * Self-serve time-off page for coaches logged into the partner app.
 * Staff coaches' home clubs can also manage this from Club → Coaches,
 * so both sides see the same list.
 */
export default function CoachTimeOff({ coachId }: { coachId: string }) {
  return (
    <div className="p-8 max-w-4xl">
      <PageHeader
        eyebrow="Coach"
        title="Time off"
        subtitle="Block your calendar for holidays, annual leave, days off, or partial-day time off. Customers can't book lessons during these windows."
      />

      <TimeOffEditor coachId={coachId} />
    </div>
  );
}
